import { createAsyncThunk } from '@reduxjs/toolkit';
import { VehicleDataService } from '../../../epics/common/commonData';
import {
    airbagKey,
    bodyTypeKey,
    cameraKey,
    clearVehicleKey,
    climateKey,
    colorInteriorKey,
    cruiseKey,
    driveunitKey,
    fuelKey,
    ownersKey,
    powerSteeringKey,
    registrationKey,
    seatsHeatKey,
    seatsTypeKey,
    transmissionKey,
    vehicleColorKey,
    vehicleColorTypeKey,
    vehicleExchangeKey,
} from '../thunkKeys/commonThunksKeys';
import { clearAirbag } from '../vehicle_reducers/airbag';
import { clearBodyType } from '../vehicle_reducers/bodyType';
import { clearCamera } from '../vehicle_reducers/camera';
import { clearClimate } from '../vehicle_reducers/climate';
import { clearColorInterior } from '../vehicle_reducers/colorInterior';
import { clearColorVehicle } from '../vehicle_reducers/colorVehicle';
import { clearColorVehicleType } from '../vehicle_reducers/colorVehicleType';
import { clearCruise } from '../vehicle_reducers/cruise';
import { clearDriveunit } from '../vehicle_reducers/driveunit';
import { clearFuel } from '../vehicle_reducers/fuel';
import { clearOwners } from '../vehicle_reducers/owners';
import { clearPowerSteering } from '../vehicle_reducers/powerSteering';
import { clearRegistration } from '../vehicle_reducers/registration';
import { clearSeatsHeat } from '../vehicle_reducers/seatsHeat';
import { clearSeatsType } from '../vehicle_reducers/seatsType';
import { clearTransmission } from '../vehicle_reducers/transmission';
import { clearVehicleExchange } from '../vehicle_reducers/vehicleExchange';

export const clearVehicleDataAction = createAsyncThunk(
    clearVehicleKey,
    (_, { dispatch }) => {
        dispatch(clearAirbag());
        dispatch(clearBodyType());
        dispatch(clearCamera());
        dispatch(clearClimate());
        dispatch(clearColorInterior());
        dispatch(clearColorVehicle());
        dispatch(clearColorVehicleType());
        dispatch(clearCruise());
        dispatch(clearDriveunit());
        dispatch(clearFuel());
        dispatch(clearOwners());
        dispatch(clearPowerSteering());
        dispatch(clearRegistration());
        dispatch(clearSeatsHeat());
        dispatch(clearSeatsType());
        dispatch(clearTransmission());
        dispatch(clearVehicleExchange());
    },
);

export const getAirbag = createAsyncThunk(airbagKey, async (_, thunkApi) => {
    try {
        const response = await VehicleDataService.getAirbag();
        return response;
    } catch (error) {
        return thunkApi.rejectWithValue(error.message);
    }
});

export const getBodyType = createAsyncThunk(
    bodyTypeKey,
    async (_, thunkApi) => {
        try {
            const response = await VehicleDataService.getBodyType();
            return response;
        } catch (error) {
            return thunkApi.rejectWithValue(error.message);
        }
    },
);

export const getCamera = createAsyncThunk(cameraKey, async (_, thunkApi) => {
    try {
        const response = await VehicleDataService.getCamera();
        return response;
    } catch (error) {
        return thunkApi.rejectWithValue(error.message);
    }
});

export const getClimate = createAsyncThunk(climateKey, async (_, thunkApi) => {
    try {
        const response = await VehicleDataService.getClimate();
        return response;
    } catch (error) {
        return thunkApi.rejectWithValue(error.message);
    }
});

export const getColorInterior = createAsyncThunk(
    colorInteriorKey,
    async (_, thunkApi) => {
        try {
            const response = await VehicleDataService.getColorInterior();
            return response;
        } catch (error) {
            return thunkApi.rejectWithValue(error.message);
        }
    },
);

export const getVehicleColor = createAsyncThunk(
    vehicleColorKey,
    async (_, thunkApi) => {
        try {
            const response = await VehicleDataService.getVehicleColor();
            return response;
        } catch (error) {
            return thunkApi.rejectWithValue(error.message);
        }
    },
);

export const getVehicleColorType = createAsyncThunk(
    vehicleColorTypeKey,
    async (_, thunkApi) => {
        try {
            const response = await VehicleDataService.getVehicleColorType();
            return response;
        } catch (error) {
            return thunkApi.rejectWithValue(error.message);
        }
    },
);

export const getCruise = createAsyncThunk(cruiseKey, async (_, thunkApi) => {
    try {
        const response = await VehicleDataService.getCruise();
        return response;
    } catch (error) {
        return thunkApi.rejectWithValue(error.message);
    }
});

export const getDriveunit = createAsyncThunk(
    driveunitKey,
    async (_, thunkApi) => {
        try {
            const response = await VehicleDataService.getDriveunit();
            return response;
        } catch (error) {
            return thunkApi.rejectWithValue(error.message);
        }
    },
);

export const getFuel = createAsyncThunk(fuelKey, async (_, thunkApi) => {
    try {
        const response = await VehicleDataService.getFuel();
        return response;
    } catch (error) {
        return thunkApi.rejectWithValue(error.message);
    }
});

export const getOwners = createAsyncThunk(ownersKey, async (_, thunkApi) => {
    try {
        const response = await VehicleDataService.getOwners();
        return response;
    } catch (error) {
        return thunkApi.rejectWithValue(error.message);
    }
});

export const getPowerSteering = createAsyncThunk(
    powerSteeringKey,
    async (_, thunkApi) => {
        try {
            const response = await VehicleDataService.getPowerSteering();
            return response;
        } catch (error) {
            return thunkApi.rejectWithValue(error.message);
        }
    },
);

export const getRegistration = createAsyncThunk(
    registrationKey,
    async (_, thunkApi) => {
        try {
            const response = await VehicleDataService.getRegistration();
            return response;
        } catch (error) {
            return thunkApi.rejectWithValue(error.message);
        }
    },
);

export const getSeatsHeat = createAsyncThunk(
    seatsHeatKey,
    async (_, thunkApi) => {
        try {
            const response = await VehicleDataService.getSeatsHeat();
            return response;
        } catch (error) {
            return thunkApi.rejectWithValue(error.message);
        }
    },
);

export const getSeatsType = createAsyncThunk(
    seatsTypeKey,
    async (_, thunkApi) => {
        try {
            const response = await VehicleDataService.getSeatsType();
            return response;
        } catch (error) {
            return thunkApi.rejectWithValue(error.message);
        }
    },
);

export const getTransmission = createAsyncThunk(
    transmissionKey,
    async (_, thunkApi) => {
        try {
            const response = await VehicleDataService.getTransmission();
            return response;
        } catch (error) {
            return thunkApi.rejectWithValue(error.message);
        }
    },
);

export const getVehicleExchange = createAsyncThunk(
    vehicleExchangeKey,
    async (_, thunkApi) => {
        try {
            const response = await VehicleDataService.getVehicleExchange();
            return response;
        } catch (error) {
            return thunkApi.rejectWithValue(error.message);
        }
    },
);
